import React from "react";
import { motion } from "framer-motion";
import "./iconGrid.css";

// 👉 Import your 19 icons
import icon1 from "../assets/icons/icon-01.png";
import icon2 from "../assets/icons/icon-02.png";
import icon3 from "../assets/icons/icon-03.png";
import icon4 from "../assets/icons/icon-04.png";
import icon5 from "../assets/icons/icon-05.png";
import icon6 from "../assets/icons/icon-06.png";
import icon7 from "../assets/icons/icon-07.png";
import icon8 from "../assets/icons/icon-08.png";
import icon9 from "../assets/icons/icon-09.png";
import icon10 from "../assets/icons/icon-10.png";
import icon11 from "../assets/icons/icon-11.png";
import icon12 from "../assets/icons/icon-12.png";
import icon13 from "../assets/icons/icon-13.png";
import icon14 from "../assets/icons/icon-14.png";
import icon15 from "../assets/icons/icon-15.png";
import icon16 from "../assets/icons/icon-16.png";
import icon17 from "../assets/icons/icon-17.png";
import icon18 from "../assets/icons/icon-18.png";
import icon19 from "../assets/icons/icon-19.png";


// ... continue till icon19

const items = [
  { icon: icon1, title: "Shirts" },
  { icon: icon2, title: "Pants" },
  { icon: icon3, title: "Baniyan" },
  { icon: icon4, title: "Turban Cap" },
  { icon: icon5, title: "Umbralla" },
  { icon: icon6, title: "Big Bag" },
  { icon: icon7, title: "Mobile Phone" },
  { icon: icon8, title: "Smart Glasses" },
  { icon: icon9, title: "" },
  { icon: icon10, title: "" },
  { icon: icon11, title: "" },
  { icon: icon12, title: "Camera" },
  { icon: icon13, title: "Laptop" },
  { icon: icon14, title: "Pendrive" },
  { icon: icon15, title: "Tablet PC" },
  { icon: icon16, title: "Smart Watch" },
  { icon: icon17, title: "Helmet" },
  { icon: icon18, title: "Remote Key" },
  { icon: icon19, title: "" },
  // Add all 19 here
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
    },
  },
};

const IconGrid = () => {
  return (
    <div className="icon-grid-section">
        <h2 className="tenders" style={{paddingLeft:'20px',marginTop:'25px',borderBottom:'1px solid orange'}}>
  Not allowed inside the Temple
</h2>
      <motion.div
        className="icon-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {items.map((item, index) => (
          <motion.div
            className="icon-card"
            key={index}
            variants={cardVariants}
            whileHover={{ scale: 1.08 }}
          >
            <div className="icon-wrapper">
              <img src={item.icon} alt={item.title} style={{width:'100px',height:'100px'}} />
            </div>
            <h4>{item.title}</h4>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default IconGrid;